import React, { FormEvent, KeyboardEvent } from 'react';
import Button from '../UI/Button';
import ChatTextArea from './ChatTextArea';
import { IconSend } from '../Icon';
import styles from './ChatInput.module.scss';
import { Tooltip } from '../UI';

interface ChatInputProps {
  value: string;
  onChange: (value: string) => void;
  onBlurChange?: (value: string) => void;
  onSubmit: () => void;
  isLoading: boolean;
  placeholder?: string;
  disabled?: boolean;
  disabledTooltip?: React.ReactNode;
}

const ChatInput: React.FC<ChatInputProps> = ({
  value,
  onChange,
  onSubmit,
  isLoading,
  placeholder,
  disabled = false,
  disabledTooltip,
  onBlurChange,
}) => {
  const isInputValid = (): boolean => {
    return value.trim().length > 0;
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (isInputValid() && !isLoading) {
      onSubmit();
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const form = (
    <form className={styles.inputContainer} onSubmit={handleSubmit}>
      <div className={styles.inputWrapper}>
        <ChatTextArea
          className={styles.textarea}
          value={value}
          onChange={onChange}
          onBlurChange={onBlurChange}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          disabled={isLoading || disabled}
          fullWidth
        />
        <Button
          type="submit"
          variant="darkGreen"
          size="medium"
          className={styles.sendButton}
          disabled={!isInputValid() || isLoading || disabled}
          icon={isLoading ? <div className={styles.loadingSpinner}></div> : <IconSend size={16} />}
          aria-label="Send message"
        />
      </div>
    </form>
  );

  if (disabled && disabledTooltip) {
    return (
      <Tooltip enabled content={disabledTooltip}>
        <div>{form}</div>
      </Tooltip>
    );
  }

  return form;
};

export default ChatInput;
